import {StyleSheet} from '@react-pdf/renderer'
import theme from '../../../../../themes/pTheme/pTheme'

// default unit is pt, Based on the standard 72 dpi PDF document), hence width,height,spacing etc are in pt. For A4, the width is 596 pt and height is 842 pt
export const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 10,
    paddingVertical: 10,
    fontFamily: 'Open Sans'
  },
  quickStatContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginVertical: 8
  },
  quickStat: {
    marginRight: 8,
    display: 'flex'
  },
  quickStatTitle: {
    fontFamily: 'Open Sans',
    color: theme.palette.hpBaseDarker,
    fontSize: 10,
    fontWeight: 600
  },
  quickStatValue: {fontFamily: 'Open Sans', fontSize: 12, fontWeight: 700, marginTop: 3},
  quickStatDivider: {
    width: 1,
    height: '100%',
    backgroundColor: theme.palette.hpBaseLight,
    marginRight: 8
  },
  imgContainer: {
    width: '100%'
  },
  mapImage: {
    maxHeight: 250,
    objectFit: 'cover',
    width: '100%'
  },
  poiLegendContainer: {
    marginTop: 10,
    height: 'auto',
    width: '120'
  },
  poiLegendImage: {maxHeight: 180, width: '100%', objectFit: 'contain'},
  legendContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: 20,
    justifyContent: 'space-between',
    width: '100%'
  },

  colorLegendContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: '50%'
  },
  textRegular: {
    fontSize: 9 // 9pt as per the standard 72 dpi PDF document
  },
  houseLegendContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    alignItems: 'center',
    columnGap: 1,
    marginTop: 4,
    marginLeft: 'auto'
  },
  houseLegendItem: {
    display: 'flex',
    flexDirection: 'row',
    marginLeft: 8,
    alignItems: 'center'
  },

  houseHoldLegendDot: {
    width: 8,
    height: 8,
    backgroundColor: theme.palette.hpAccentPink,
    borderRadius: 50,
    marginRight: 4
  },
  enrolledHouseholdDot: {backgroundColor: theme.palette.heatmapColor.greenDark},
  notEnrolledHouseholdDot: {backgroundColor: theme.palette.hpAccentVioletPink},

  chip: {border: `1px solid ${theme.palette.hpBaseLight}`, paddingHorizontal: 6, paddingVertical: 4, borderRadius: 75},
  chipContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: 15,
    marginBottom: 5,
    flexWrap: 'wrap',
    gap: 3
  },
  semiBoldFont: {
    fontWeight: 'semibold'
  },
  personaLegendContainerRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 10
  },
  personaLegendItemRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
    marginRight: 10
  },
  personaLegendDot: {
    width: 10,
    height: 10,
    marginRight: 5
  },
  personaLegendTitle: {
    marginTop: '12px',
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 5
  },
  boldText: {
    fontSize: 9,
    fontWeight: 'bold'
  }
})
